import { write } from "shp-write";
import geojson  from "shp-write/src/geojson";
import { saveAs } from 'file-saver';
import JSZip from "jszip";
import prj_defs from './prj_defs.js';

export default function (gj, options) {
  const zip = new JSZip();
  let name = options && options.folder ? options.folder : 'layers';
  name = name.replace(new RegExp("[\\ -/:]+", 'g'), "_");
  const layers = zip.folder(name);

  [geojson.point(gj), geojson.line(gj), geojson.polygon(gj)].forEach((l) => {
    if (l.geometries.length && l.geometries[0].length) {
      write(l.properties, l.type, l.geometries, (err, files) => {
        const fileName = options && options.types && options.types[l.type.toLowerCase()] 
          ? options.types[l.type.toLowerCase()] 
          : l.type;
          
        layers.file(`${fileName}.shp`, files.shp.buffer, {
          binary: true
        });
        layers.file(`${fileName}.shx`, files.shx.buffer, {
          binary: true
        });
        layers.file(`${fileName}.dbf`, files.dbf.buffer, {
          binary: true
        });
        layers.file(`${fileName}.prj`, prj_defs[options.srid || 'EPSG:2180']);
				layers.file(`${fileName}.cpg`, '88592');
      }, 'ISO-8859-2');
    }
  });
  
  zip.generateAsync({
    type: 'blob',
    compression: 'STORE'
  }).then((content) => {
    saveAs(content, `aquagis.zip`);
  });
};



// WEBPACK FOOTER //
// ./src/utils/ShpGenerate.js